import React from 'react';

export default function MessengerIcon({ className }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			aria-hidden="true"
			focusable="false"
		>
			<path
				fill="currentColor"
				d="M12 0C5.373 0 0 4.975 0 11.111 0 14.608 1.745 17.727 4.472 19.763V24l4.086-2.242c1.09.301 2.246.464 3.442.464 6.627 0 12-4.974 12-11.111C24 4.975 18.627 0 12 0zm1.193 14.963-3.056-3.259-5.963 3.259L10.733 8l3.13 3.259 5.889-3.259z"
			/>
		</svg>
	);
}
